  <div class="step-preview">
    <div class="step-preview-buttons">
      <div class="step-preview-buttons-fr">
        <button  class="button-icon size-m primary-button" (click)="viewPayment()"
             [disabled]="!contractStep?.payment_data" >
          <mat-icon svgIcon="file-search-fill"> </mat-icon>
          <span> {{'CONTRACTS.CARD.VIEW'|translate}}</span>
        </button>
      </div>
      <div class="step-preview-buttons-sr">
        <button  class="button-icon size-m secondary-button"
          [disabled]="contractData?.rights?.isContractBlockedForEdit === true"
          (click)="addPayment()">
          <mat-icon [svgIcon]="contractStep?.payment_data? 'edit-2-fill' : 'add-circle-fill' "> </mat-icon>
          <span> {{(contractStep?.payment_data? 'CONTRACTS.CARD.EDIT' : 'CONTRACTS.CARD.ADD')|translate}} </span>
        </button>
        <button  class="button-icon size-m secondary-button"
          [disabled]="contractData?.rights?.isContractBlockedForEdit === true">
          <mat-icon svgIcon="refresh-fill"> </mat-icon>
          <span>
            {{'CONTRACTS.CARD.CLEAR'|translate}}
          </span>
        </button>
      </div>
<!--             <div class="step-preview-buttons-fr">
        <button  class="wide-button button-icon primary-light clone">
          <div  class="action-icon contract-icon-delete light-icon step-preview-buttons-fr"></div>
          <span>
            {{'CONTRACTS.CARD.DELETE'|translate}}
          </span>
        </button>
      </div> -->
    </div>
  </div>
